import { render, staticRenderFns } from "./AttachmentEdit.vue?vue&type=template&id=6ec89412&scoped=true"
import script from "./AttachmentEdit.vue?vue&type=script&lang=js"
export * from "./AttachmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec89412",
  null
  
)

export default component.exports